import { z } from "zod";
import { timezoneCheckedProfileData } from "../timezone.js";
export const OnboardingProfileSchema = z.object({
    userId: z.string(),
    currentStep: z.string(),
    isComplete: z.boolean(),
    data: z.record(z.string(), z.unknown()),
    allergens: z.array(z.string()).default([]),
    dietaryLabels: z.array(z.string()).default([]),
    completedAt: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const GetOnboardingResponse = z.object({
    onboarding: OnboardingProfileSchema.nullable(),
});
// The wizard writes the same timezone keys the profile screen does, into the
// same jsonb the fleet-wide AT TIME ZONE queries read.
export const UpdateOnboardingRequest = z.object({
    currentStep: z.string().min(1).optional(),
    data: timezoneCheckedProfileData.optional(),
    allergens: z.array(z.string()).optional(),
    dietaryLabels: z.array(z.string()).optional(),
});
export const UpdateOnboardingResponse = z.object({
    onboarding: OnboardingProfileSchema,
});
export const CompleteOnboardingResponse = z.object({
    onboarding: OnboardingProfileSchema,
    /** What activation managed to build. `microstepsReady: false` means the
     *  member is about to meet a plan with no steps in it. */
    plan: z.object({
        status: z.enum(["generated", "existing", "skipped", "failed", "pending"]),
        planId: z.string().nullable(),
        planDay: z.number().int().positive(),
        microstepsReady: z.boolean(),
    }),
});
export const OnboardingIdentitySchema = z.object({
    becoming: z.string().min(1).max(120),
    destination: z.string().min(1).max(120),
    vow: z.string().min(1).max(280),
});
export const GenerateIdentityRequest = z.object({
    refresh: z.boolean().optional(),
    // The wizard's in-progress onboarding data, so the identity reflects the
    // current journey without waiting for it to be persisted server-side.
    data: z.record(z.string(), z.unknown()).optional(),
});
export const GenerateIdentityResponse = z.object({
    identity: OnboardingIdentitySchema,
    grounded: z.boolean(),
});
//# sourceMappingURL=onboarding.js.map